import type { LucideIcon } from 'lucide-react'
import { Cloud, Globe, MessageCircle, Send } from 'lucide-react'

export interface ChannelInfo {
  label: string
  icon: LucideIcon
  iconClassName: string
}

/**
 * Información del canal fuera del `.map()`. Sin logos de terceros: la
 * iconografía es neutral (`lucide-react`), como exige AGENTS.md.
 */
export function getChannelInfo(instance: { name: string; channelType?: string }): ChannelInfo {
  const key = (instance.channelType || instance.name).toLowerCase()

  if (key.includes('telegram')) {
    return { label: 'Telegram', icon: Send, iconClassName: 'bg-sky-50 text-sky-600' }
  }
  if (key.includes('webchat') || key.includes('web')) {
    return { label: 'WebChat', icon: Globe, iconClassName: 'bg-purple-50 text-purple-600' }
  }
  if (key.includes('cloud')) {
    return { label: 'WA Cloud', icon: Cloud, iconClassName: 'bg-blue-50 text-blue-600' }
  }
  return { label: 'WhatsApp', icon: MessageCircle, iconClassName: 'bg-emerald-50 text-emerald-600' }
}
